import TrainingList from "./components/TrainingList";

window.addEventListener("DOMContentLoaded", (event) => {
    new TrainingList().init();
})
